import { AltHintBadge } from "../AltHintBadge/AltHintBadge.jsx";
import "./AltHintTarget.css";

export function AltHintTarget({
  as: Tag = "div",
  label,
  visible = false,
  fill = false,
  className = "",
  targetRef = null,
  children,
  ...props
}) {
  const resolvedClassName = [
    "alt-hint-target",
    fill ? "alt-hint-target--fill" : "",
    visible ? "alt-hint-target--visible" : "",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag class={resolvedClassName} ref={targetRef} {...props}>
      <AltHintBadge label={label} visible={visible} />
      {children}
    </Tag>
  );
}
